import { render, staticRenderFns } from "./ButtonsNav.vue?vue&type=template&id=aa682184&scoped=true&"
import script from "./ButtonsNav.vue?vue&type=script&lang=js&"
export * from "./ButtonsNav.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsNav.vue?vue&type=style&index=0&id=aa682184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa682184",
  null
  
)

export default component.exports